export default function PonchoIcon({ name, scale, className, ...props }) {
  const localClassName = [
    (!!name && `icono-arg-${name}`) || "",
    (!!scale && `fa-${scale}`) || "",
    ...className.split(" "),
  ]
    .join(" ")
    .trim();
  return <i className={localClassName}></i>;
}

PonchoIcon.defaultProps = {
  className: "",
};
